import React from 'react';
import { MapPin, Phone, MessageCircle, Clock, ChevronRight, Navigation, Send } from 'lucide-react';
import { businessInfo } from '../../data/mock';

export const ContactSection = () => {
  return (
    <section id="kontak" className="relative bg-[#0a0a0a] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#00FFD1] text-sm font-medium tracking-wider uppercase mb-4">
            Lokasi & Kontak
          </span>
          <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
            Hubungi Kami{' '}
            <span className="text-[#00FFD1]">Sekarang</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Konsultasikan masalah Android Anda dengan tim profesional kami. 
            Kami siap membantu!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Contact Info */}
          <div className="space-y-6">
            {/* Address Card */}
            <div className="bg-black border border-white/10 p-8 hover:border-[#00FFD1]/30 transition-all duration-400">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#00FFD1] flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-black" />
                </div>
                <div>
                  <h3 className="text-white text-lg font-semibold mb-2">Alamat</h3>
                  <p className="text-white/70 leading-relaxed">
                    {businessInfo.address.street}<br />
                    {businessInfo.address.district}<br />
                    {businessInfo.address.city}
                  </p>
                  <a 
                    href={businessInfo.mapLink}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#00FFD1] text-sm mt-4 hover:gap-3 transition-all"
                  >
                    <Navigation className="w-4 h-4" />
                    Lihat di Google Maps
                  </a>
                </div>
              </div>
            </div>

            {/* Phone Card */}
            <div className="bg-black border border-white/10 p-8 hover:border-[#00FFD1]/30 transition-all duration-400">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#00FFD1] flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-black" />
                </div>
                <div>
                  <h3 className="text-white text-lg font-semibold mb-2">Telepon</h3>
                  <a 
                    href={`tel:${businessInfo.phone}`}
                    className="text-white/70 text-xl hover:text-[#00FFD1] transition-colors"
                  >
                    {businessInfo.phone}
                  </a>
                  <p className="text-white/50 text-sm mt-2">Klik untuk menelepon langsung</p>
                </div>
              </div>
            </div>

            {/* Hours Card */}
            <div className="bg-black border border-white/10 p-8 hover:border-[#00FFD1]/30 transition-all duration-400">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#00FFD1] flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-black" />
                </div>
                <div>
                  <h3 className="text-white text-lg font-semibold mb-2">Jam Operasional</h3>
                  <p className="text-white/70">{businessInfo.operationalHours}</p>
                  <div className="flex items-center gap-2 mt-3">
                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                    <span className="text-green-400 text-sm">Buka Sekarang</span>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href={businessInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex-1 inline-flex items-center justify-between gap-3 bg-[#00FFD1] hover:bg-[#00FFD1]/10 text-black hover:text-[#00FFD1] px-6 py-4 min-h-[56px] font-medium text-lg transition-all duration-400"
              >
                <span className="flex items-center gap-3">
                  <MessageCircle className="w-5 h-5" />
                  WhatsApp
                </span>
                <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href={businessInfo.telegramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex-1 inline-flex items-center justify-between gap-3 bg-[#0088cc] hover:bg-[#0088cc]/10 text-white hover:text-[#0088cc] px-6 py-4 min-h-[56px] font-medium text-lg transition-all duration-400"
              >
                <span className="flex items-center gap-3">
                  <Send className="w-5 h-5" />
                  Telegram
                </span>
                <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>

          {/* Google Maps Embed */}
          <div className="h-full min-h-[400px] lg:min-h-[600px]">
            <div className="w-full h-full bg-[#121212] border border-white/10 overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.7063!2d107.0489!3d-6.2897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e698f9dc8b7777f%3A0x8e9f9b8e9b8e9b8e!2sMekarsari%2C%20Kec.%20Tambun%20Sel.%2C%20Kabupaten%20Bekasi%2C%20Jawa%20Barat%2017510!5e0!3m2!1sid!2sid!4v1700000000000!5m2!1sid!2sid"
                width="100%"
                height="100%"
                style={{ border: 0, filter: 'grayscale(100%) invert(92%) contrast(83%)' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="NOZEN FLASHER Location"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
